import Modal from './Modal';
import IModalProps from './Modal.props';
import ModalBody from './ModalBody';
import IModalBodyProps from './ModalBody.props';
import ModalFooter from './ModalFooter';
import IModalFooterProps from './ModalFooter.props';
import ModalHeader from './ModalHeader';
import IModalHeaderProps from './ModalHeader.props';

export {
    Modal,
    IModalProps,
    ModalHeader,
    IModalHeaderProps,
    ModalBody,
    IModalBodyProps,
    ModalFooter,
    IModalFooterProps
};